import { useQuery } from "@tanstack/react-query";
import { getEntityList } from "~/services/browser";
import * as APITypes from "~/API";

export const useGetEntityList = ({
  entityType,
  ownerID,
  ownerType,
}: {
  entityType: APITypes.EntityType;
  ownerID: string;
  ownerType: APITypes.OwnerType;
}) => {
  const result = useQuery({
    queryKey: ["useGetEntityList", entityType],
    queryFn: () => getEntityList({ entityType, ownerID, ownerType }),
    staleTime: 5 * 1000,
    enabled: entityType && ownerID !== "",
  });
  return result;
};
